// Funnel measurement (14/10/26): scroll depth, quiz steps, WhatsApp hand-off outcome — all through the ONE tracker door
// (POST /api/track -> he_user_events). No new endpoint. Passive listeners, sendBeacon, never throws, no UI.
import { getSessionId } from '@/lib/trackerSession';
import { abCtx } from '@/lib/abClient';
// @ts-ignore — plain browser JS module
import { getClickIds, interacted } from '@/lib/trackClient.mjs';

export function fx(event: string, metadata: Record<string, any> = {}, extra: Record<string, any> = {}): void {
  try {
    const payload = JSON.stringify({
      event, sessionId: getSessionId(), page: location.pathname + location.search, metadata, ...abCtx(),
      categorySlug: (() => { try { return decodeURIComponent(location.pathname.split('/')[1] || '') || null; } catch { return null; } })(),
      client: { screenW: window.screen?.width, screenH: window.screen?.height, viewportW: window.innerWidth, viewportH: window.innerHeight,
        language: navigator.language, referrer: document.referrer || null, ...getClickIds(), interacted: interacted() },
      ...extra,
    });
    if (navigator.sendBeacon) navigator.sendBeacon('/api/track', new Blob([payload], { type: 'text/plain' }));
    else fetch('/api/track', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: payload, keepalive: true }).catch(() => {});
  } catch {}
}

// ── WhatsApp hand-off outcome ──
// tap -> wa_open_attempt. Then: page hidden within 3 s -> wa_app_left (app very likely opened); still visible after 3 s ->
// wa_open_stayed (likely no app / blocked / failed); visible again after wa_app_left -> wa_return {secs}.
let waBusy = 0;
export function waHandoff(via: string, meta: Record<string, any> = {}): void {
  try {
    const now = Date.now();
    if (now - waBusy < 1500) return; waBusy = now; // one tap = one attempt (a link click and openWhatsApp can both see it)
    const t0 = now; let left = 0; let decided = false;
    fx('wa_open_attempt', { via, ...meta });
    const onVis = () => {
      if (document.visibilityState === 'hidden') {
        if (!left && !decided) { decided = true; left = Date.now(); fx('wa_app_left', { via, ms: left - t0 }); }
        else if (!left) { left = Date.now(); } // hidden later than 3 s (after wa_open_stayed): still track the return
      } else if (left) {
        fx('wa_return', { via, secs: Math.round((Date.now() - left) / 1000) });
        left = 0; cleanup();
      }
    };
    const cleanup = () => { document.removeEventListener('visibilitychange', onVis); window.removeEventListener('pagehide', onHide); };
    const onHide = () => onVis();
    document.addEventListener('visibilitychange', onVis, { passive: true } as any);
    window.addEventListener('pagehide', onHide, { passive: true } as any);
    setTimeout(() => {
      if (!decided) { decided = true; if (document.visibilityState === 'visible') fx('wa_open_stayed', { via, ms: Date.now() - t0 }); else { left = left || Date.now(); fx('wa_app_left', { via, ms: Date.now() - t0, late: 1 }); } }
      setTimeout(cleanup, 10 * 60 * 1000);
    }, 3000);
  } catch {}
}

export function isWaHref(href: string): boolean {
  try { const u = new URL(href, location.href); return /(^|\.)wa\.me$|whatsapp\.com$/.test(u.hostname) || /^\/(wa|wa-amp)\//.test(u.pathname) && u.origin === location.origin || u.protocol === 'whatsapp:'; } catch { return false; }
}

// ── scroll depth 25/50/75/100, once per page view ──
export function makeScrollDepth(): { onScroll: () => void; reset: () => void } {
  let fired: Record<number, 1> = {};
  return {
    reset: () => { fired = {}; },
    onScroll: () => {
      const d = document.documentElement; const scrollable = d.scrollHeight - d.clientHeight;
      if (scrollable < 120) return; // a page that barely scrolls has no depth to report
      const pct = Math.min(100, Math.round(((window.scrollY + 0) / scrollable) * 100));
      for (const m of [25, 50, 75, 100]) if (pct >= (m === 100 ? 98 : m) && !fired[m]) { fired[m] = 1; fx('scroll_depth', { pct: m, h: d.scrollHeight }); }
    },
  };
}
